import getStringDateAndHourFromDate from '../../../localUtils/getStringDateAndHourFromDate'

export default function getSevenDaysAgo() {
  const today = new Date()
  const sevenDaysAgo = new Date()

  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7)

  const stringToday = getStringDateAndHourFromDate(today)
  const stringSevenDaysAgo = getStringDateAndHourFromDate(sevenDaysAgo)

  const options = {
    name: 'SEVEN_DAYS_AGO',
    label: '1 semana',
    startDate: stringSevenDaysAgo.date,
    finalDate: stringToday.date,
    startHour: '00:00',
    finalHour: '23:59',
  }

  return options
}
